import TextToPng from './components/TextToPng';
import './App.css';

function App() {
  return (
    <div className="App">
      <TextToPng />
    </div>
  );
}

export default App;
